<script>
export default {
    name: "PatientRegistrationReport",

    data() {

        return {
            patients: [],
            filter: {
                dateFrom: window.moment().format('YYYY-MM-DD'),
                dateTo: window.moment().format('YYYY-MM-DD'),
                page: 1,
                pageSize: 10,
            },
        };
    },

    watch: {

        "filter.pageSize"() {

            this.fetchPatients();
        },

        "filter.page"() {

            this.fetchPatients();
        },
    },

    mounted() {

        this.fetchPatients();
    },

    methods: {

        fetchPatients() {

            this.$root.loading = true;
            let url = `PatientsReports/GetPatientRegistrationReport?Page=${this.filter.page}&pagesize=${this.filter.pageSize}&Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
            url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
            return this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },

        printRegistrationReport() {

            window.open(`/reports/patients/registration-report/print?page=${this.filter.page}&pageSize=${this.filter.pageSize}&dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>Registration report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Patient Reports: Registration Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input v-model.trim="filter.search" type="text" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="$root.checkAuth('AccessOldData')
                ">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom"
                    id="grid-date-from" class="input-control input-sm text-xs" >
              </div> 
              <div class="md:w-1/6 sm:w-full p-tiny" v-if="!$root.checkAuth('AccessOldData')">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" :min="$root.minFilterDate"
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input v-model="filter.dateTo" type="date" id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-16 sm:w-12 p-tiny mt-4">
                  <tail-select>
                      <template v-slot:field>
                          <select v-model="filter.pageSize" class="input-control input-sm text-xs">
                              <option :value="10">10</option>
                              <option :value="25">25</option>
                              <option :value="50">50</option>
                              <option :value="100">100</option>
                              <option :value="200">200</option>
                              <option :value="500">500</option>
                          </select>
                        </template>
                  </tail-select>
              </div>
              <div class="md:w-1/12 sm:w-1/2 flex flex-row mt-3 mx-1">
                <div class="flex-1 whitespace-no-wrap">
                    <a href="javascript:void(0)"
                      class="text-blue-800 text-xs" 
                      @click.prevent="function() { if(filter.page <= 1) return; filter.page--}">
                          <span><i class="fa fa-caret-left"></i> Previous</span>
                    </a>
                </div>
                <div class="text-sm font-bold w-16 my-px mx-1">
                    <input type="number" v-model="filter.page" disabled class="input-control input-sm text-xs text-right disabled">
                </div>
                <div class="flex-1 whitespace-no-wrap">
                    <a href="javascript:void(0)" class="text-blue-800 text-xs" @click.prevent="filter.page++">
                          <span>Next <i class="fa fa-caret-right"></i></span>
                    </a>
                </div>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-3 mx-2">
                  <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchPatients"><i class="fa fa-filter"></i> Filter</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-3">
                  <button 
                    class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="$root.exportToExcel(`patient-registration-report`, `patientRegistrationTable`)">
                        <i class="fa fa-file-excel"></i> Export</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-3">
                  <button 
                    class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="printRegistrationReport"><i class="fa fa-print"></i> Print</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="patientRegistrationTable">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/12">MRN</th>
                            <th class="p-tiny w-1/6">Names</th>
                            <th class="p-tiny w-1/12">IP No</th>
                            <th class="p-tiny w-1/12">OP No</th>
                            <th class="p-tiny w-1/12">ID No</th>
                            <th class="p-tiny w-1/12">DOB</th>
                            <th class="p-tiny w-1/12">Reg Date</th>
                            <th class="p-tiny w-1/12">CellPhone</th>
                            <th class="p-tiny w-1/12">Visits(s)</th>
                            <th class="p-tiny w-1/6">Username</th>
                        </tr>
                  </thead>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:65vh;">
                      <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                          <td class="p-tiny w-1/12">{{ patient.patienT_ID }}</td>
                          <td class="p-tiny w-1/6">{{ patient.names }}</td>
                          <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                          <td class="p-tiny w-1/12">{{ patient.opfileno }}</td>
                          <td class="p-tiny w-1/12" v-if="$root.checkAuth(`AccessPhoneNo`)">{{ patient.nationalid }}</td>
                          <td class="p-tiny w-1/12" v-if="!$root.checkAuth(`AccessPhoneNo`)">{{ patient.maskedNationalID }}</td>
                          <td class="p-tiny w-1/12">{{ patient.dob | dateFormat }}</td>
                          <td class="p-tiny w-1/12">{{ patient.regdate | dateFormat }}</td>
                          <td class="p-tiny w-1/12" v-if="$root.checkAuth(`AccessPhoneNo`)">{{ patient.CellPhone }}</td>
                          <td class="p-tiny w-1/12" v-if="!$root.checkAuth(`AccessPhoneNo`)">{{ patient.maskedCellPhone }}</td>
                          <td class="p-tiny w-1/12">{{ patient.visitCount }}</td>
                          <td class="p-tiny w-1/6">{{ patient.username }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>